import { History } from 'history';
import postal from 'postal';

export const NavigationType =  {
  newPage: 'NEW_PAGE',
  jobMenuSwitch: 'JOB_MENU_SWITCH',
};

let index = 1;

export let newModeURLId = 0;

export function decreaseUrlId() {
  newModeURLId--;
}

export function openNewPage(history:History,
  link:string,
  navigationType:string,
  metadata:any|null=null,
  afterScreenUrl: string|null = null, /* Used to make sure new screen is on stack after this url */
  params: any|null=null
) {
  const channel = postal.channel('ifms-navigation');

  // Payment의 경우 New Mode가 중복으로 열릴 수 있고 Customer/Vendor가 있는 경우 Customer/Vendor Id가 URL 뒤에 설정된다. 
  // Customer/Vendor가 없는 경우 음수 값을 설정해서 New Mode를 여러개 열 수 있게함.
  if (!link.includes('Payment/add/') && link.includes('Payment/add')) {
    decreaseUrlId();
    link = link + `/${newModeURLId}`;
  }

  if (!!metadata) {
    history.push(link, {
      type: navigationType,
      index: index++,
      afterScreenUrl,
      params: {...params},
    });
  
    // Duplicate push so we can handle back button in correct way
    history.push(link, {
      type: navigationType,
      index: index++,
      afterScreenUrl,
      metadata: { ...metadata },
      params: {...params},
    });

  } else {
    history.push(link, {
      type: navigationType,
      index: index++,
      afterScreenUrl,
      metadata: { ...metadata },
      params: {...params},
    });
  
    // Duplicate push so we can handle back button in correct way
    history.push(link, {
      type: navigationType,
      afterScreenUrl,
      index: index++,
      params: {...params},
    });
  }

  channel.publish('ifms-navigation.urlChange', link);
}
